var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class I3TouchEx {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoSelection = '1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /\:(\d{2})G0000/i,
                callback: (match) => {
                    this.socket.send(`:${match[1]}r000${this.power ? '1' : '2'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\:(\d{2})S000(\d)/i,
                callback: (match) => {
                    this.power = match[2] === '3' ? true : false;
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /\:(\d{2})G\:000/i,
                callback: (match) => {
                    this.socket.send(`:${match[1]}r:${this.videoSelection.padStart(3, '0')}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /\:(\d{2})S\:(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[2] ? match[2] : '001';
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\:(\d{2})G8000/i,
                callback: (match) => {
                    this.socket.send(`:${match[1]}r8${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /\:(\d{2})S8(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volume = parseInt(match[2], 10);
                        this.socket.send(`4${match[1]}+`);
                    }
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\:(\d{2})G9000/i,
                callback: (match) => {
                    this.socket.send(`:${match[1]}r900${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\:(\d{2})S9(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volumeMute = match[2] === '001' ? true : false;
                        this.socket.send(`4${match[1]}+`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`401-`);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 4664 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1';
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 4664 || this.power);
    }
}
I3TouchEx.emulatorType = 'socketEmulator';
I3TouchEx.key = '-MWiq0w_HGu3bSIdTY7w';
